import React from 'react'
import PropTypes from 'prop-types'
import { constants, links } from 'common/helpers'

import NeedDataModal from '../NeedDataModal/NeedDataModal'

import messages from './messages'


const NeedCardUpdateModal = ({ name, data: { item } }) => (
  <NeedDataModal {...{ name, messages, item, link: links.cardUpdate }} />
)

NeedCardUpdateModal.propTypes = {
  name: PropTypes.string,
  data: PropTypes.shape({
    item: PropTypes.object.isRequired,
  }).isRequired,
}

NeedCardUpdateModal.defaultProps = {
  name: constants.modals.premiumProducts.NeedCardUpdate,
}


export default NeedCardUpdateModal
